import Helpers from 'application/Shared/Helpers/Functions';

const Payload = (() => {
    const hasData = (field) => {
        if (!Array.isArray(field)) {
            return false;
        }

        if (!Helpers.isset(field, 0)) {
            return false;
        }

        if (field[0] === '0') {
            return false;
        }

        return true;
    };

    const idString = (ids) => `[${ids.join(',')}]`;

    const responseMap = (respData, field) => {
        const map = {};

        respData.forEach((data) => {
            if (!data) {
                return;
            }

            map[data[field]] = data;
        });

        return map;
    };

    return {
        hasData,
        idString,
        responseMap
    };
})();

export default Payload;
